<template>
  <Modal :title="title" :visible="visibleModal" @onCancel="$emit('onCancel')" :viewDetail="true" :isCustomButton="true">
    <a-row type="flex" :gutter="[24, 24]" justify="center">
      <template v-if="data.length > 0">
        <a-col :span="10">
          <div class="history-list-container">
            <HistoryList :data="data" @onHistoryActive="onHistoryActive" />
          </div>
        </a-col>
        <a-col :span="14">
          <HistoryDetail :data="historyActive" :page="page" />
        </a-col>
      </template>
      <template v-else>
        <a-empty>
          <template #description> No History </template>
        </a-empty>
      </template>
    </a-row>
    <template #button>
      <Button type="primary" @click="$emit('onCancel')">Close</Button>
    </template>
  </Modal>
</template>

<script>
import { Button, Modal } from "@/components";
import HistoryList from "./HistoryList.vue";
import HistoryDetail from "./HistoryDetail.vue";
import { LEAVE_CARRYOVER_SCREEN } from "@/utils";
import { computed } from "vue";
export default {
  name: "HistoryModal",
  components: {
    Modal,
    HistoryList,
    HistoryDetail,
    Button,
  },
  provide() {
    return {
      activeId: computed(() => this.activeId),
    };
  },
  props: {
    visibleModal: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Leave Carryover History",
    },
    data: {
      type: Array,
      default: () => [],
    },
    page: {
      type: String,
      default: LEAVE_CARRYOVER_SCREEN,
    },
  },
  watch: {
    data() {
      if (this.data?.length > 0) {
        this.onHistoryActive(this.data[0]);
      }
    },
  },
  data() {
    return {
      historyActive: null,
      activeId: null,
    };
  },
  created() {
    if (this.data?.length > 0) {
      this.onHistoryActive(this.data[0]);
    }
  },
  methods: {
    onHistoryActive(history) {
      const { new_record, id } = history;
      this.activeId = id;
      this.historyActive = new_record ?? null;
    },
  },
};
</script>

<style lang="scss" scoped>
.history-list-container {
  height: 100%;
  max-height: 500px;
}
</style>
